// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__qFnBR","authBtn":"auth_authBtn__KNwb7","fileLabel":"auth_fileLabel__n14Nl"};